import { render } from "./callToActionSplitBlock.vue?vue&type=template&id=69888893&scoped=true&ts=true"
import script from "./callToActionSplitBlock.vue?vue&type=script&lang=ts"
export * from "./callToActionSplitBlock.vue?vue&type=script&lang=ts"

import "./callToActionSplitBlock.vue?vue&type=style&index=0&id=69888893&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69888893"]])

export default __exports__